<template>
  <v-card outlined rounded="lg" class="pa-5">
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Total Income</p>
      <p class="font-weight-medium">{{asMoney(affordabilityResults.grossIncome)}}</p>
    </div>
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Total Taxable Income</p>
      <p class="font-weight-medium">{{asMoney(affordabilityResults.totalTaxableIncome)}}</p>
    </div>
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Grand Total Payments</p>
      <p class="font-weight-medium">{{asMoney(affordabilityResults.totalPayments)}}</p>
    </div>
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Income After Debt & Expenses</p>
      <p class="font-weight-medium">{{asMoney(affordabilityResults.finalIncome)}}</p>
    </div>
    
    <div v-for="(item, index) in ratioResults" :key="index">
      <v-divider class="mb-5" />
      <div class="d-flex justify-space-between align-center text-subtitle-2">
          <p class="text--secondary">{{item.ratioName}}</p>
          <p class="font-weight-medium">{{asPercent(item.ratio)}}</p>
      </div>
      <div class="d-flex justify-space-between align-center text-subtitle-2">
        <p class="text--secondary">Status</p>
          <v-chip label small :color="item.ratingColor">{{item.rating || '-' | capitalize}}</v-chip>
      </div>
      <v-alert :value="true" class="pa-1 mt-2" color="error" outlined v-if="item.stopFlow">
        This is in violation of the stopper limit of {{item.stopperLimit}} %.
      </v-alert>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    affordabilityResults: {
      type: Object,
      default: () =>({
        finalIncome: 0,
        grossIncome: 0,
        totalDebts: 0,
        totalPayments: 0,
        totalTaxableIncome: 0,
        totalStatutoryDeductions: 0,
        totalNonStatutoryDeductions: 0,
        dsrCalculations: [],
      })
    } 
  },
  computed: {
    ratioResults: function() {
      return this.affordabilityResults?.dsrCalculations || [];
    }
  }
};
</script>
